<script>
import UListViewGroup from 'cloud-ui.vusion/src/components/u-list-view.vue/group.vue';

export default {
    name: 'van-grid-view-group',
    parentName: 'van-grid-view',
    childName: 'van-grid-view-item',
    extends: UListViewGroup,
}
</script>
